export const BASIC_FEATURES = [
    'Доступ к каталогу шин и дисков',
    'Базовый поиск по поставщикам',
    'История платежей и статус подписки',
    'Email-уведомления по оплате',
];

export const BUSINESS_FEATURES = [
    'Командная работа и роли',
    'Подключение нескольких сотрудников',
    'Оплата по счёту',
    'Персональные условия сопровождения',
];

/** Пункты блока «Что входит в Business» в модалке обсуждения (макет TyreBase) */
export const BUSINESS_MODAL_FEATURES = [
    'Несколько пользователей',
    'Индивидуальные условия оплаты',
    'Закрывающие документы',
    'Персональное сопровождение',
];
